module.exports = __webpack_public_path__ + "static/media/photoInactive.fcef54f4.svg";